import React from 'react'
import cx from 'classnames'

import Icon from 'components/_new/ui/Icon/Icon'

import s from './Checkmark.scss'


export const CheckmarkColors = [ 'brandWhite', 'transparentWhite', 'whiteBrand' ] as const

// <bg color><icon color>
type CheckmarkColor = typeof CheckmarkColors[number]

type CheckmarkProps = {
  className?: string
  iconClassName?: string
  color?: CheckmarkColor
}

const Checkmark: React.FunctionComponent<CheckmarkProps> = (props) => {
  const { className, iconClassName, color = 'whiteBrand' } = props

  const rootClassName = cx(s.checkmark, className, s[color])

  return (
    <div className={rootClassName} data-testid="checkmarkIcon">
      <Icon className={cx(s.icon, iconClassName)} name="checkmark" noWrapper />
    </div>
  )
}


export default Checkmark
